var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReturnsArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 67 67"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2d2d2d",
  fillRule: "evenodd",
  d: "M33.5 62.3c15.9 0 28.7-12.9 28.7-28.7S49.4 4.8 33.5 4.8 4.8 17.7 4.8 33.6a28.64 28.64 0 0 0 28.7 28.7m0 3.8c18 0 32.6-14.6 32.6-32.6S51.5 1 33.5 1 .9 15.6.9 33.6s14.6 32.5 32.6 32.5m16.1-33.7c0-1.1-.9-1.9-1.9-1.9h-23l4.8-4.3c1-.9 1-2.6-.1-3.5-.8-.6-1.9-.6-2.6.1l-8.5 8a2.34 2.34 0 0 0-.7 1.7c0 .6.2 1.3.7 1.7l8.5 8c.7.7 1.8.7 2.6.1 1.1-.8 1.1-2.5.1-3.5l-5-4.5h23.2c1.1 0 1.9-.9 1.9-1.9"
})));
export default SvgReturnsArrow;